import React from 'react';

import { Box } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import Modal from 'components/modal';
import { useEnableMapListExperiment } from 'experiments/use-enable-map-list-experiment';
import StoreLocator from 'pages/store-locator';
import { StoreLocator as StoreLocatorExperiment } from 'pages/store-locator-experiment';

export const ModalContent = Box.withConfig({
  width: 'full',
  backgroundColor: Styles.color.white,
  height: '100%',
});

/**
 *
 * StoreSelectorModal
 * This component is a wrapper for the StoreLocator component.
 * It is used to easily select a store and fill the form with the store details.
 * it is used when pypestream is disabled and the user is in the support form.
 */
export const StoreSelectorModal: React.FC<React.PropsWithChildren<{
  onDismiss: () => void;
  onStoreSelect: (storeId: string) => Promise<void>;
}>> = ({ onDismiss, onStoreSelect }) => {
  const { formatMessage } = useIntl();
  const enableMapListExperiment = useEnableMapListExperiment();

  const handleSelectStore = (storeId: string) => {
    onStoreSelect(storeId);
    onDismiss();
  };

  return (
    <Modal
      amplitudeEventData={{ modalAppearanceEventMessage: 'Store Locator Modal' }}
      onDismiss={onDismiss}
      // Disable scrolling allows us to move only the list while keeping other elements fixed.
      withScroll={false}
      allowsDismiss
      header={formatMessage({ id: 'selectLocation' })}
    >
      <ModalContent testID="support-form-v2-store-selector-refresh">
        {enableMapListExperiment ? (
          <StoreLocatorExperiment
            onDismissInSupportForm={onDismiss}
            isInSupportForm
            onSelectStore={handleSelectStore}
          />
        ) : (
          <StoreLocator
            onDismissInSupportForm={onDismiss}
            isInSupportForm
            handleSelectStore={handleSelectStore}
          />
        )}
      </ModalContent>
    </Modal>
  );
};
